module.exports = __webpack_public_path__ + "static/homeGTK.4bbb25c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homeGTK.png
// module id = 841
// module chunks = 35783957827783